import { StyleFn } from './index'

export type StylesKeys = 'buttonsWrapper'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  buttonsWrapper: StyleFn
}

export const defaultStyles: Styles = {
  buttonsWrapper: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gridArea: 'btn',
  }),
}
